import { ComingSoonPage } from "../components/ComingSoonPage";

export function AlertsPage() {
	return (
		<ComingSoonPage
			title="Alerts"
			subtitle="Pro tier. Substitution threshold, geographic surge, catalog drop, variant emergence."
			arrivesIn="v1.1"
			detail={[
				"Maximum 3 alert emails per week per manufacturer.",
				"Templated takeaways — no LLM-generated narratives, by design.",
				"Pro tier only. Configurable from Settings → Alerts once enabled.",
			]}
		/>
	);
}
